import { render, staticRenderFns } from "./ClientCertificateDetails.vue?vue&type=template&id=5908bdd4"
import script from "./ClientCertificateDetails.vue?vue&type=script&lang=js"
export * from "./ClientCertificateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports